const state = () => ({
  token: localStorage.getItem('token') || null,
  user: JSON.parse(localStorage.getItem('user') || 'null'),
  rol: localStorage.getItem('rol') || null,
  agencia: localStorage.getItem('agencia') || null
})

const getters = {
  isAuthenticated: (s) => !!s.token,
  token: (s) => s.token,
  user: (s) => s.user,
  rol: (s) => s.rol,
  agencia: (s) => s.agencia
}

const mutations = {
  setToken(state, token) {
    state.token = token
    if (token) localStorage.setItem('token', token)
    else localStorage.removeItem('token')
  },
  setUser(state, user) {
    state.user = user
    if (user) localStorage.setItem('user', JSON.stringify(user))
    else localStorage.removeItem('user')
  },
  setRol(state, rol) {
    state.rol = rol
    if (rol) localStorage.setItem('rol', rol)
    else localStorage.removeItem('rol')
  },
  setAgencia(state, agencia) {
    state.agencia = agencia
    if (agencia) localStorage.setItem('agencia', agencia)
    else localStorage.removeItem('agencia')
  },
  clearAuth(state) {
    state.token = null
    state.user = null
    state.rol = null
    state.agencia = null
    localStorage.removeItem('token')
    localStorage.removeItem('user')
    localStorage.removeItem('rol')
    localStorage.removeItem('agencia')
  }
}

const actions = {
  login({ commit }, { token, user, rol, agencia }) {
    commit('setToken', token)
    commit('setUser', user)
    commit('setRol', rol)
    commit('setAgencia', agencia)
  },
  logout({ commit }) {
    commit('clearAuth')
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
